<!-- <script setup lang="ts">
</script> -->
<template>
    <button
      class="btn-outline"
    >
        Cancel
    </button>
</template>